module.exports = __webpack_public_path__ + "static/img/tab.8df82443.png";